import { AuthFetchWithResponse } from '@e3dc-react/shell/Types/api'
import { handleFetchError } from 'src/Libs/api/utils'
import { ApiResult } from 'src/Libs/api'
import { ValidateSapCustomerDto } from './dto/sap.dto'
import { ValidateSapCustomer } from '../models'
import { sapValidationDtoToModelTransformer } from './transformer'
import { StatusCodes } from '@e3dc-react/shell/Libs'

/**
 * Validate sap customer by id
 * @param sapCustomerId id of sap customer
 * @returns true if sap customer valid
 */
export const validateSapCustomer = async (sapCustomerId: string, authFetch: AuthFetchWithResponse): Promise<ApiResult<ValidateSapCustomer>> => {
  try {
    const response = await authFetch<ValidateSapCustomerDto>({
      path: `sap/${sapCustomerId}/validate`,
      method: 'GET',
    })
    if (response.status === StatusCodes.OK) {
      const transformedData = sapValidationDtoToModelTransformer(response.data)
      return new ApiResult<ValidateSapCustomer>(transformedData, false)
    }

    return new ApiResult<ValidateSapCustomer>(null, true)
  } catch (error) {
    return handleFetchError<ValidateSapCustomer>(error)
  }
}
